import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import FormLogin from "../../forms/FormLogin";
import FormRecuperacaoSenha from "../../forms/FormRecuperacaoSenha";
import { login, enviarEmailRecuperacaoSenha } from "../../../actions/auth";
import { Container, Card, Transition } from "semantic-ui-react";

class Login extends Component {
  state = {
    pagina: true
  };

  componentDidMount = () => {
    if (this.props.match.params.action)
      (this.props.match.params.action === "recuperar-senha") ? this.setState({ pagina: false }) : this.props.history.push("/login");
  }

  submitLogin = data =>
    this.props.login(data.email, data.senha).then(() => this.props.history.push(this.props.redirect));

  submitEnviarEmailRecuperacaoSenha = data =>
    this.props.enviarEmailRecuperacaoSenha(data.email);

  submitRecuperarSenha = data =>
    this.props.recuperarSenha(data)
      .then(usuario => usuario);

  trocaPagina = () => {
    this.setState({ pagina: !this.state.pagina })
  }

  render() {
    const { pagina } = this.state;
    return (
      <div>
        <div className="ui-pagina-login">
          <div className="ui-login-logo">
            <Link to="/">
              {/* <img src="/assets/imagens/logo.jpg" alt="Logo Connect Games Festival" /> */}
            </Link>
          </div>
          <div>
            <Container>
              <Card fluid style={styles.card}>
                <Card.Content>
                  <Card.Header style={styles.header}>
                    <Transition duration={{ show: 600, hide: 0 }} animation="fly left" visible={pagina}>
                      <div>
                        <span>Login</span>
                        <Transition duration={{ show: 600, hide: 0 }} animation="fly left" visible={this.props.redirect !== "/dashboard"}>
                          <span style={styles.messageRedirect}>Você precisa estar logado para acessar essa página</span>
                        </Transition>
                        <Transition duration={{ show: 1000, hide: 0 }} animation="fly left" visible={!!!localStorage.tokenExpired} transitionOnMount={true}>
                          <span style={styles.messageRedirect} className="erro-inline text-center">{localStorage.tokenExpired}</span>
                        </Transition>
                      </div>
                    </Transition>
                    {/* <Transition duration={{ show: 600, hide: 0 }} animation="fly left" visible={!pagina}>
                      <span>Esqueci minha senha</span>
                    </Transition> */}
                  </Card.Header>
                </Card.Content>
                <Card.Content>

                  {(pagina) ?
                    <FormLogin submit={this.submitLogin} />
                    :
                    <FormRecuperacaoSenha submit={this.submitEnviarEmailRecuperacaoSenha} />
                  }

                </Card.Content>
                {/* <Card.Content>
                  <Transition duration={{ show: 600, hide: 0 }} animation="fly left" visible={pagina}>
                    <div style={styles.cardLink} onClick={this.trocaPagina}>
                      Esqueci minha senha
                    </div>
                  </Transition>
                  <Transition duration={{ show: 600, hide: 0 }} animation="fly left" visible={!pagina}>
                    <div style={styles.cardLink} onClick={this.trocaPagina}>
                      Fazer Login
                    </div>
                  </Transition>
                </Card.Content> */}
              </Card>
            </Container>
          </div>
        </div>
      </div>
    );
  }
}

Login.defaultProps = {
  redirect: "/dashboard"
}

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  login: PropTypes.func.isRequired,
  redirect: PropTypes.string,
  enviarEmailRecuperacaoSenha: PropTypes.func.isRequired
}

const styles = {
  divTitulo: {
    textAlign: "center",
  },
  titulo: {
    fontSize: "20px",
    fontWeight: 100,
    padding: "10px"
  },
  header: {
    padding: "10px 0 2px 0",
    textAlign: "center"
  },
  card: {
    padding: "5px 15px 0px 15px",
    margin: "auto",
    marginBottom: "40px",
    marginTop: "30px",
    overflow: "hidden",
    maxWidth: "400px"
  },
  cardLink: {
    fontSize: "13px",
    color: "#2185e0",
    partidar: "pointer",
    textAlign: "center"
  },
  messageRedirect: {
    fontSize: "11px",
    fontWeight: 100,
    marginTop: "8px",
  }
}

export default connect(null, { login, enviarEmailRecuperacaoSenha })(Login);
